import { Button, MenuItem, Select } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { React, useEffect, useRef, useState } from 'react';
import './taurus.css';

import { ChevronLeftOutlined, ChevronRightOutlined, RefreshOutlined } from '@material-ui/icons';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

function TaurusClient() {
    const [region, setRegion] = useState('lca');

    const [data, setData] = useState({});
    const [cacheBuster, setCacheBuster] = useState(Date.now());
    const [openMap, setOpenMap] = useState(false);
    const [selectedDayAndSlot, setSelectedDayAndSlot] = useState({ day: '', slot: '', globalIndex: 0, data: {} });

    useEffect(() => {
        const regionNames = { lca: 'All You Can Surf', lmi: "Lady's Mile", pet: 'Petounda' };
        document.title = `Taurus Weather Forecast ${regionNames[region] || region} `;
        getData();
    }, [region]);

    const getData = async () => {
        try {
            const response = await fetch(`https://admin.nicosiasailingclub.com/api/taurus/${region}`);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            setCacheBuster(Date.now());
            setData(data);
        } catch (err) {
            console.error('Failed to fetch taurus data for region ' + region, err);
            setData({});
        }
    };

    const info = data.info;
    const timeSlots = ['00', '03', '06', '09', '12', '15', '18', '21'];
    //given this format:
    //{"id":"03","url":"https://www.mgm.gov.tr/FTPDATA/sht/ww3/Taurus_W03.png","title":"Mon 15:00GMT","min":"10.0","max":"14.0","average":"12.3"},
    //Group by day (first part of title) then by time (second part of title)
    // Use timeSlots const timeSlots=['00','03','06','09','12','15','18','21']; for list of valid slots. foe each day we want to have all timeslots. if one is missing from data then leave blank but include it in the array
    //so get list of days and create a new object with day as key and all timeSlots as empty array elements
    //then fill each data and timeslot with data if available
    const groupedData = {};
    if (data.data) {
        data.data.forEach((item) => {
            const day = item.title.split(' ')[0];
            const time = item.title.split(' ')[1].split(':')[0];
            if (!groupedData[day]) {
                groupedData[day] = {};
                timeSlots.forEach((slot) => {
                    groupedData[day][parseInt(slot)] = {};
                });
            }
            groupedData[day][parseInt(time)] = item;
        });
    }

    function getMapUrl() {
        if (selectedDayAndSlot.day === '' || selectedDayAndSlot.slot === '') {
            return '';
        }
        const day = selectedDayAndSlot.day;
        const slot = selectedDayAndSlot.slot;
        return groupedData[day][slot].url;
    }

    function colorize(value) {
        //to max integer
        const color = (value / 2).toFixed(0);
        return `ws${color} ${parseInt(value) < 11 ? 'light' : 'dark'}`;
    }

    useEffect(() => {
        // Preload all map images
        Object.keys(groupedData).forEach((day) => {
            Object.keys(groupedData[day]).forEach((slot) => {
                const data = groupedData[day][slot];
                if (data.url) {
                    const img = new Image();
                    img.src = data.url + `?${cacheBuster}`;
                }
            });
        });
    }, [data?.info, cacheBuster]);
    const carouselRef = useRef(null);

    function handleClick(day, slot, globalIndex) {
        const data = groupedData[day][slot];
        setSelectedDayAndSlot({ day: day, slot: slot, globalIndex: globalIndex, data: data });
        setOpenMap(true);
    }

    const handleCarouselChange = (index) => {
        const dayIndex = Math.floor(index / 8);
        const slotIndex = index % 8;
        const day = Object.keys(groupedData)[dayIndex];
        const slot = Object.keys(groupedData[day])[slotIndex];
        const data = groupedData[day][slot];
        setSelectedDayAndSlot({ day: day, slot: slot, globalIndex: index, data: data });
    };

    function handleNext() {
        const currentIndex = selectedDayAndSlot.globalIndex;
        if (!isAtEnd()) handleCarouselChange(selectedDayAndSlot.globalIndex + 1);
    }
    function handlePrevious() {
        if (!isAtStart()) handleCarouselChange(selectedDayAndSlot.globalIndex - 1);
    }

    function isAtStart() {
        return selectedDayAndSlot.globalIndex === 0;
    }
    function isAtEnd() {
        return !(selectedDayAndSlot.globalIndex < data?.data?.length || 0);
    }

    function handleRegionChange(event) {
        setRegion(event.target.value);
    }
    return (
        <>
            <Dialog
                open={openMap}
                onClose={() => setOpenMap(false)}
                maxWidth={'sm'}
                style={{ padding: 2 }}
                PaperProps={{ style: { top: '20px', position: 'absolute' } }}
            >
                <div className={'dialogHeader'}></div>
                <Carousel
                    ref={carouselRef}
                    swipeable={false}
                    emulateTouch
                    useKeyboardArrows={true}
                    showIndicators={false}
                    showArrows={false}
                    dynamicHeight={true}
                    selectedItem={selectedDayAndSlot.globalIndex}
                    showThumbs={false}
                    onChange={handleCarouselChange}
                    transitionTime={0}
                    autoFocus={true}
                >
                    {Object.keys(groupedData).map((day) => {
                        return Object.keys(groupedData[day]).map((slot) => {
                            const data = groupedData[day][slot];
                            return (
                                <div key={`${day}${slot}`}>
                                    {data.url && <img src={`${data.url}?${cacheBuster}`} alt={'map'} width={'100%'} />}
                                </div>
                            );
                        });
                    })}
                </Carousel>
                <DialogActions>
                    <div className={'dialogActions'}>
                        <div className={'dialogData'}>
                            <div className={'dialogDataHeader'}>
                                <div className={'data dayTime'}>Day/Time</div>
                                <div className={`data`}>Min</div>
                                <div className={`data`}>Max</div>
                                <div className={`data`}>Avg</div>
                            </div>

                            <div className={'dialogDataData'}>
                                <div className={'data dayTime'}>
                                    {selectedDayAndSlot.day} {selectedDayAndSlot.slot}:00
                                </div>
                                <div className={`data min ${colorize(selectedDayAndSlot.data.min)}`}>
                                    {selectedDayAndSlot.data.min}
                                </div>
                                <div className={`data max ${colorize(selectedDayAndSlot.data.max)}`}>
                                    {selectedDayAndSlot.data.max}
                                </div>
                                <div className={`data avg ${colorize(selectedDayAndSlot.data.average)}`}>
                                    {selectedDayAndSlot.data.average}
                                </div>
                            </div>
                        </div>
                        <div className={'dialogButtons'}>
                            <div className={'nav'}>
                                <Button
                                    variant={'outlined'}
                                    startIcon={<ChevronLeftOutlined />}
                                    onClick={handlePrevious}
                                    disabled={isAtStart()}
                                    size={'small'}
                                    //style={{ width: 120, justifyContent: 'flex-start' }}
                                >
                                    Previous
                                </Button>
                                <Button
                                    variant={'outlined'}
                                    endIcon={<ChevronRightOutlined />}
                                    onClick={handleNext}
                                    disabled={isAtEnd()}
                                    size={'small'}
                                    //style={{ width: 120, justifyContent: 'flex-end' }}
                                >
                                    Next
                                </Button>
                            </div>
                        </div>
                        <div className={'close'}>
                            <Button onClick={() => setOpenMap(false)} variant={'text'}>
                                close
                            </Button>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
            <div className={'footer'}>
                <h1>Taurus forecast</h1>
                <div>
                    <Button variant={'text'} onClick={getData} endIcon={<RefreshOutlined />}>
                        Updated: {info?.lastUpdate || ''}
                    </Button>
                </div>
                <Select name="lang" onChange={handleRegionChange} value={region}>
                    <MenuItem value="lca">All You Can Surf</MenuItem>
                    <MenuItem value="pet">Petounda</MenuItem>
                    <MenuItem value="lmi">Lady's Mile</MenuItem>
                </Select>
            </div>
            <div className="dayContainer">
                {groupedData &&
                    Object.keys(groupedData).map((day, dayIndex) => {
                        return (
                            <>
                                <div>
                                    <div className="dayRow">
                                        <div className={'data header'}>{day}</div>
                                        {Object.keys(groupedData[day]).map((slot) => {
                                            return (
                                                <div key={slot} className="data times">
                                                    {slot}
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div key={day} className="dayRow">
                                        <div className={'dayData'}>
                                            <div className={'data min label'}>min</div>
                                            <div className={'data max label'}>max</div>
                                            <div className={'data avg label'}>avg</div>
                                        </div>
                                        {Object.keys(groupedData[day]).map((slot, slotIndex) => {
                                            const data = groupedData[day][slot];
                                            const hasData = data.min || data.max || data.average;
                                            const globalIndex = dayIndex * 8 + slotIndex;
                                            const isSelected =
                                                selectedDayAndSlot.day === day && selectedDayAndSlot.slot === slot;
                                            return (
                                                <div key={slot} className={`dayData ${isSelected ? 'selected' : ''}`}>
                                                    {hasData ? (
                                                        <div
                                                            onClick={() => {
                                                                handleClick(day, slot, globalIndex);
                                                            }}
                                                        >
                                                            <div className={`data min ${colorize(data.min)}`}>
                                                                {data.min}
                                                            </div>
                                                            <div className={`data max ${colorize(data.max)}`}>
                                                                {data.max}
                                                            </div>
                                                            <div className={`data avg ${colorize(data.average)}`}>
                                                                {data.average}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className={'data min'}></div>
                                                            <div className={'data max'}></div>
                                                            <div className={'data avg'}></div>
                                                        </>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </>
                        );
                    })}
            </div>
        </>
    );
}

export default TaurusClient;
